import { BrowserRouter, Route, Routes } from "react-router-dom";

import AuthService from './services/AuthService';
import Navigationbar from "./components/navigation/Navigationbar";
import WelcomePage from "./pages/Homepage";
import SecuredPage from "./pages/Securedpage";
import ReviewSuppliers from "./pages/ReviewSuppliers";
import FollowUp from "./pages/FollowUpPage";
import ReviewSupplierPage from "./pages/ReviewSupplierPage";
import NullReportingSupplierPage from "./pages/NullReportingSupplierPage";
import CreateEmailTemplatePage from "./pages/CreateEmailTemplatePage";
import EmailTemplatePage from "./pages/EmailTemplatePage";
import ContactMembersPage from "./pages/ContactMembersPage";
import FollowUpSending from "./pages/FollowUpSending";

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import MemberInvoiceReviewPage from "./pages/MemberInvoiceReviewPage";

import NullReportingReviewPage from "./pages/NullReportingReviewPage";
import { NewFooter } from "./components/Footer/NewFooter";
import FollowUpPhoneReviewPage from "./pages/FollowUpPhoneReviewPage";

declare global {
  var AppSettings: {
    APIprefix: string;
    KCprefix: string;
  }
}
library.add(fas)

function App() {
  const [isAppSettingsLoaded, setAppSettingsLoaded] = useState(false);
  useEffect(() => {
    fetch("/appSettings.json")
      .then((a) => a.json())
      .then((settings) => {
        window.AppSettings = settings;
        setAppSettingsLoaded(true);
      })
      .catch((e) => console.error(e));
  }, []);

  return (
    <>
      {isAppSettingsLoaded && (
        <>
          <Navigationbar />
          <div className="app-content-root">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<WelcomePage />} />
                <Route path="/secured" element={<SecuredPage />} />
                <Route path="/review-suppliers" element={<ReviewSuppliers />} />
                <Route path="/reviewsupplier/:orgNr" element={<ReviewSupplierPage />} />
                <Route path="/nullreporting/:orgNr" element={<NullReportingSupplierPage />} />
                <Route path="/nullreporting/reviews/new" element={<NullReportingReviewPage />} />
                <Route path="/nullreporting/reviews/:id" element={<NullReportingReviewPage />} />
                <Route path="/follow-up" element={<FollowUp />} />
                <Route path="/memberreviewinvoice/:key" element={<MemberInvoiceReviewPage />} />
                <Route path="/email-templates/create" element={<CreateEmailTemplatePage />} />
                <Route path="/email-templates/edit/:id" element={<CreateEmailTemplatePage />} />
                <Route path="/email-templates" element={<EmailTemplatePage />} />
                <Route path="/supplier/:orgNr/contact-members" element={<ContactMembersPage />} />
                <Route path="/followup-sending/:sendingId" element={<FollowUpSending />} />
                <Route path="/followup/phone-review/:id" element={<FollowUpPhoneReviewPage />} />
              </Routes>
            </BrowserRouter>
          </div>
            {/* <NewFooter/> */}
        </>
      )}
    </>
  );
}
export default App;
